(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bubbles-angels-brand-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initBrandStoryVideo = (section) => {
      if (!section || section.dataset.brandStoryVideoInitialized === 'true') {
        return;
      }

      const openButton = section.querySelector('[data-brand-story-video-open]');
      const dialog = section.parentElement.querySelector('[data-brand-story-video-modal]');

      if (!openButton || !dialog) {
        return;
      }

      section.dataset.brandStoryVideoInitialized = 'true';

      const closeButton = dialog.querySelector('[data-brand-story-video-close]');
      const iframe = dialog.querySelector('[data-brand-story-video-frame]');
      const uploadedVideo = dialog.querySelector('[data-brand-story-uploaded-video]');

      const resetMedia = () => {
        if (uploadedVideo) {
          uploadedVideo.pause();
          uploadedVideo.currentTime = 0;
        }

        if (iframe) {
          iframe.removeAttribute('src');
        }
      };

      const closeDialog = () => {
        resetMedia();

        if (dialog.open) {
          dialog.close();
        }

        document.body.classList.remove('brand-story-video-open');
      };

      openButton.addEventListener('click', () => {
        dialog.showModal();
        document.body.classList.add('brand-story-video-open');

        if (iframe && iframe.dataset.src) {
          iframe.src = iframe.dataset.src;
        }

        if (uploadedVideo) {
          uploadedVideo.currentTime = 0;
          const playPromise = uploadedVideo.play();

          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
        }
      });

      if (closeButton) {
        closeButton.addEventListener('click', closeDialog);
      }

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) {
          closeDialog();
        }
      });

      dialog.addEventListener('close', () => {
        document.body.classList.remove('brand-story-video-open');
        resetMedia();
      });
    };

    document.querySelectorAll('[data-brand-story-section]').forEach(initBrandStoryVideo);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bubbles-angels-collection-landing-editorial-panel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initEditorialPanelVideo = (section) => {
      if (!section || section.dataset.collectionLandingEditorialPanelInitialized === 'true') {
        return;
      }

      const openButton = section.querySelector('[data-collection-landing-editorial-panel-open]');
      const dialog = section.querySelector('[data-collection-landing-editorial-panel-modal]');

      if (!openButton || !dialog) {
        return;
      }

      section.dataset.collectionLandingEditorialPanelInitialized = 'true';

      const closeButton = dialog.querySelector('[data-collection-landing-editorial-panel-close]');
      const iframe = dialog.querySelector('[data-collection-landing-editorial-panel-frame]');
      const uploadedVideo = dialog.querySelector('[data-collection-landing-editorial-panel-uploaded-video]');

      const resetMedia = () => {
        if (uploadedVideo) {
          uploadedVideo.pause();
          uploadedVideo.currentTime = 0;
        }

        if (iframe) {
          iframe.removeAttribute('src');
        }
      };

      const closeDialog = () => {
        resetMedia();

        if (dialog.open) {
          dialog.close();
        }

        document.body.classList.remove('collection-landing-editorial-panel-video-open');
      };

      openButton.addEventListener('click', () => {
        dialog.showModal();
        document.body.classList.add('collection-landing-editorial-panel-video-open');

        if (iframe && iframe.dataset.src) {
          iframe.src = iframe.dataset.src;
        }

        if (uploadedVideo) {
          uploadedVideo.currentTime = 0;
          const playPromise = uploadedVideo.play();

          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
        }
      });

      if (closeButton) {
        closeButton.addEventListener('click', closeDialog);
      }

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) {
          closeDialog();
        }
      });

      dialog.addEventListener('close', () => {
        document.body.classList.remove('collection-landing-editorial-panel-video-open');
        resetMedia();
      });
    };

    document.querySelectorAll('[data-collection-landing-editorial-panel]').forEach(initEditorialPanelVideo);

    document.addEventListener('shopify:section:load', (event) => {
      if (!event.target) {
        return;
      }

      const section = event.target.querySelector('[data-collection-landing-editorial-panel]');

      if (section) {
        initEditorialPanelVideo(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bubbles-angels-pdp-best-for"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initBestFor = (section) => {
      if (!section || section.dataset.baBestForBound === 'true') {
        return;
      }

      const mobileMedia = window.matchMedia('(max-width: 749px)');
      const viewport = section.querySelector('.bubbles-angels-pdp-best-for__viewport');
      const track = section.querySelector('[data-best-for-track]');
      const slides = Array.from(section.querySelectorAll('[data-best-for-slide]'));

      if (!viewport || !track || slides.length < 2) {
        return;
      }

      section.dataset.baBestForBound = 'true';

      let currentIndex = 0;
      let startX = 0;
      let startY = 0;
      let deltaX = 0;
      let pointerIsDown = false;
      let isDragging = false;
      let capturedPointerId = null;

      const syncTrack = (offset = 0) => {
        if (!mobileMedia.matches) {
          track.style.transform = '';
          return;
        }

        const activeSlide = slides[currentIndex];

        if (!activeSlide) {
          return;
        }

        track.style.transform = `translateX(${-(activeSlide.offsetLeft) + offset}px)`;
      };

      const endDrag = () => {
        if (!pointerIsDown) {
          return;
        }

        if (isDragging) {
          const threshold = Math.min(viewport.offsetWidth * 0.18, 72);

          if (deltaX > threshold && currentIndex > 0) {
            currentIndex -= 1;
          } else if (deltaX < -threshold && currentIndex < slides.length - 1) {
            currentIndex += 1;
          }
        }

        pointerIsDown = false;
        isDragging = false;
        capturedPointerId = null;
        deltaX = 0;
        viewport.classList.remove('is-dragging');
        track.classList.remove('is-dragging');
        syncTrack();
      };

      viewport.addEventListener('pointerdown', (event) => {
        if (!mobileMedia.matches) {
          return;
        }

        startX = event.clientX;
        startY = event.clientY;
        deltaX = 0;
        pointerIsDown = true;
        capturedPointerId = event.pointerId;
      });

      viewport.addEventListener('pointermove', (event) => {
        if (!mobileMedia.matches || !pointerIsDown) {
          return;
        }

        const dx = event.clientX - startX;
        const dy = event.clientY - startY;

        if (!isDragging) {
          const absDx = Math.abs(dx);
          const absDy = Math.abs(dy);

          if (absDx > 8 && absDx > absDy) {
            isDragging = true;
            viewport.classList.add('is-dragging');
            track.classList.add('is-dragging');
            viewport.setPointerCapture(capturedPointerId);
          } else if (absDy > 8) {
            pointerIsDown = false;
            capturedPointerId = null;
          }

          return;
        }

        deltaX = dx;
        syncTrack(deltaX);
      });

      viewport.addEventListener('pointerup', endDrag);
      viewport.addEventListener('pointercancel', endDrag);
      window.addEventListener('resize', () => syncTrack());
      mobileMedia.addEventListener('change', () => syncTrack());

      syncTrack();
    };

    document.querySelectorAll('[data-pdp-best-for]').forEach(initBestFor);

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('[data-pdp-best-for]');
      if (section) {
        initBestFor(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bubbles-angels-pdp-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initPdpReviews = (section) => {
      if (!section || section.dataset.baReviewsBound === 'true') {
        return;
      }

      const desktopMedia = window.matchMedia('(min-width: 768px)');
      const viewport = section.querySelector('.bubbles-angels-pdp-reviews__viewport');
      const track = section.querySelector('[data-testimonial-track]');
      const slides = Array.from(section.querySelectorAll('[data-testimonial-slide]'));
      const progress = section.querySelector('[data-testimonial-progress]');

      if (!viewport || !track || !progress || slides.length === 0) {
        return;
      }

      section.dataset.baReviewsBound = 'true';

      let currentIndex = 0;
      let startX = 0;
      let startY = 0;
      let deltaX = 0;
      let pointerIsDown = false;
      let isDragging = false;
      let capturedPointerId = null;

      const syncProgress = () => {
        if (slides.length < 2) {
          progress.style.transform = 'translateX(0)';
          return;
        }

        const maxOffset = viewport.offsetWidth - progress.offsetWidth;
        const ratio = currentIndex / Math.max(slides.length - 1, 1);
        progress.style.transform = `translateX(${Math.max(0, maxOffset * ratio)}px)`;
      };

      const syncTrack = (offset = 0) => {
        if (!desktopMedia.matches) {
          track.style.transform = '';
          progress.style.transform = 'translateX(0)';
          return;
        }

        const activeSlide = slides[currentIndex];

        if (!activeSlide) {
          return;
        }

        track.style.transform = `translateX(${-(activeSlide.offsetLeft) + offset}px)`;
        syncProgress();
      };

      const endDrag = () => {
        if (!pointerIsDown) {
          return;
        }

        if (isDragging) {
          const threshold = Math.min(viewport.offsetWidth * 0.18, 72);

          if (deltaX > threshold) {
            currentIndex = currentIndex === 0 ? slides.length - 1 : currentIndex - 1;
          } else if (deltaX < -threshold) {
            currentIndex = Math.min(currentIndex + 1, slides.length - 1);
          }
        }

        pointerIsDown = false;
        isDragging = false;
        capturedPointerId = null;
        deltaX = 0;
        viewport.classList.remove('is-dragging');
        track.classList.remove('is-dragging');
        syncTrack();
      };

      viewport.addEventListener('pointerdown', (event) => {
        if (!desktopMedia.matches) {
          return;
        }

        startX = event.clientX;
        startY = event.clientY;
        deltaX = 0;
        pointerIsDown = true;
        capturedPointerId = event.pointerId;
      });

      viewport.addEventListener('pointermove', (event) => {
        if (!desktopMedia.matches || !pointerIsDown) {
          return;
        }

        const dx = event.clientX - startX;
        const dy = event.clientY - startY;

        if (!isDragging) {
          const absDx = Math.abs(dx);
          const absDy = Math.abs(dy);

          if (absDx > 8 && absDx > absDy) {
            isDragging = true;
            viewport.classList.add('is-dragging');
            track.classList.add('is-dragging');
            viewport.setPointerCapture(capturedPointerId);
          } else if (absDy > 8) {
            pointerIsDown = false;
            capturedPointerId = null;
          }

          return;
        }

        deltaX = dx;
      });

      viewport.addEventListener('pointerup', endDrag);
      viewport.addEventListener('pointercancel', endDrag);
      window.addEventListener('resize', () => syncTrack());

      syncTrack();
    };

    document.querySelectorAll('[data-pdp-reviews]').forEach(initPdpReviews);

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('[data-pdp-reviews]');
      if (section) {
        initPdpReviews(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
